/**
 * Delegated handlers for QR code buttons and selects rendered via:
 *   - qala_qr_codes/action/render_qr_code_button
 *   - qala_qr_codes/action/render_qr_code_select
 *
 * Clicks/changes fetch a QR code from the REST endpoint and insert it as an
 * <img> directly after the trigger. The shared dialog handler in
 * qr-image-dialog.js takes over from there for fullscreen view.
 */

const BUTTON_SELECTOR = '.qala-qr-codes__qr-button';
const SELECT_SELECTOR = '.qala-qr-codes__qr-select';
const IMAGE_CLASS = 'qala-qr-codes__qr-image';
const IMAGE_WITH_DIALOG_CLASS = 'qala-qr-codes__qr-image--with-dialog';

function getEndpoint() {
	const config = ( typeof window !== 'undefined' && window.QalaQRCodes ) || {};
	return config.restEndpoint || '';
}

function removeAdjacentImage( anchor ) {
	const next = anchor.nextElementSibling;
	if ( next && next.classList.contains( IMAGE_CLASS ) ) {
		next.remove();
		return true;
	}
	return false;
}

function insertQRImage( anchor, src ) {
	const hasDialog = ! anchor.hasAttribute( 'data-no-dialog' );
	const img = document.createElement( 'img' );

	img.src = src;
	img.alt = '';
	img.className = hasDialog
		? `${ IMAGE_WITH_DIALOG_CLASS } ${ IMAGE_CLASS }`
		: IMAGE_CLASS;

	if ( ! hasDialog ) {
		img.dataset.noDialog = '';
	}

	anchor.insertAdjacentElement( 'afterend', img );
}

function fetchAndRender( string, anchor ) {
	const endpoint = getEndpoint();
	if ( ! endpoint || ! string ) {
		return;
	}

	anchor.disabled = true;

	fetch( endpoint, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify( { data: string } ),
	} )
		.then( response => response.json() )
		.then( data => {
			anchor.disabled = false;
			if ( data && data.qr_code ) {
				insertQRImage( anchor, data.qr_code );
			}
		} )
		.catch( () => {
			anchor.disabled = false;
		} );
}

document.addEventListener( 'click', e => {
	const button = e.target.closest( BUTTON_SELECTOR );
	if ( ! button ) {
		return;
	}

	if ( removeAdjacentImage( button ) ) {
		return;
	}

	fetchAndRender( button.getAttribute( 'data-qr-string' ), button );
} );

document.addEventListener( 'change', e => {
	const select = e.target.closest( SELECT_SELECTOR );
	if ( ! select ) {
		return;
	}

	removeAdjacentImage( select );
	fetchAndRender( select.value, select );
} );
